import { createSlice } from "@reduxjs/toolkit";
import { openMenu, closeMenu, showMenu, hideMenu } from "./menu.actions";

const initialState = {
    isOpen: false,
    isShown: false,
};

const menuSlice = createSlice({
    name: "menu",
    initialState,
    reducers: {
        open: openMenu,
        close: closeMenu,
        show: showMenu,
        hide: hideMenu,
    },
});

export const { open, close, show, hide } = menuSlice.actions;

export default menuSlice.reducer;
